import { useEffect, useState } from 'react';

/**
 * Custom hook that provides the current time and updates it periodically.
 * This enables components to display live-updating relative timestamps.
 *
 * @param intervalMs - Update interval in milliseconds (default: 60000ms = 1 minute)
 * @returns Current Date object that updates at the specified interval
 */
export function useCurrentTime(intervalMs: number = 60000): Date {
  const [currentTime, setCurrentTime] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return currentTime;
}
